import _defer from 'lodash/defer';
import store from 'store';

const LocalStorageKey = '_locations';

class LocationActions {
  constructor() {
    this.generateActions(
      'searchSuccess', 'searchFail',
      'updateCurrentSuccess', 'updateCurrentFail',
      'readUserLocationsSuccess',
      'updateUserLocationsSuccess'
    );
  }

  search(query) {
    return (dispatch, alt) =>
      alt.resolve(async () => {
        try {
          const response = await alt.request({
            url: '/locations',
            params: {
              q: query
            }
          });
          this.searchSuccess(response);
        } catch (error) {
          console.log(error);
          this.searchFail({ error });
        }
      });
  }

  clearSearchResults() {
    return () => {
      this.searchSuccess([]);
    };
  }

  updateCurrent(location) {
    return (dispatch, alt) =>
      alt.resolve(async () => {
        try {
          const response = await alt.request({
            url: '/locations/current',
            method: 'put',
            data: location
          });
          this.updateCurrentSuccess(response);
        } catch (error) {
          console.log(error);
          this.updateCurrentFail({ error });
        }
      });
  }

  readUserLocations() {
    return (dispatch, alt) =>
      alt.resolve(async () => {
        const locations = store.get(LocalStorageKey) || [];
        _defer(() => this.readUserLocationsSuccess(locations));
      });
  }

  updateUserLocations(userLocations) {
    return (dispatch, alt) =>
      alt.resolve(async () => {
        store.set(LocalStorageKey, userLocations || []);
        _defer(() => this.updateUserLocationsSuccess(userLocations));
      });
  }
}

export default LocationActions;



// WEBPACK FOOTER //
// ./app/flux/actions/Location.js